import { RootState } from '@/domain/store';

import { PositionGeocode } from '../position-geocode/position-geocode.entity';
import { TourEvent } from './entities/project-tour-ontour-event.entity';
import { TourSequence } from './entities/project-tour-ontour-sequence.entity';
import { TourTravel } from './entities/project-tour-ontour-travel.entity';

export const selectProjectTourOnTourSequences = (
  state: RootState,
): TourSequence[] => {
  return state.projectTourOntour.tourSequences;
};

export const selectProjectTourOnTourSequenceById =
  (sequenceId: number) =>
  (state: RootState): TourSequence | undefined => {
    return state.projectTourOntour.tourSequences.find(
      (item) => item.id === sequenceId,
    );
  };

export const selectProjectTourOnTourCurrentSequence = (
  state: RootState,
): TourSequence | undefined => {
  const currentSequenceId = state.projectTourOntour.currentSequenceId;
  if (currentSequenceId === null) {
    return undefined;
  }
  return selectProjectTourOnTourSequenceById(currentSequenceId)(state);
};

export const selectProjectTourOnTourEvents = (
  state: RootState,
): TourEvent[] => {
  const tourEvents = [...state.projectTourOntour.tourEvents];
  tourEvents.sort(
    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
  );
  return tourEvents;
};

export const selectProjectTourOnTourTravels = (
  state: RootState,
): TourTravel[] => {
  return state.projectTourOntour.tourTravels;
};

export const selectProjectTourOnTourTravelById =
  (tourTravelId: number) =>
  (state: RootState): TourTravel | undefined => {
    return state.projectTourOntour.tourTravels.find(
      (item) => item.id === tourTravelId,
    );
  };

// eslint-disable-next-line unused-imports/no-unused-vars
export const selectPreviousEntryCanBeReused = (state: RootState): boolean => {
  // could be done :
  // -  use getPreviousTourTravelWithSameConnectionType from src/domain/project-tour-ontour/actions/submit-impact-co2-answers-from-previous-entry.action.ts
  // - check if I can copy answer or not (co2 answer linked to specific travel
  // i don't do it should check i shouild make fethc
  // i will do it later when all answerrs will be in redux
  return true;
};

export const selectProjectTourOnTourIsFetchingTourEvents = (
  state: RootState,
): boolean => {
  return state.projectTourOntour.isFetchingTourEvents;
};

export const selectProjectTourOnTourIsFetchingTourTravels = (
  state: RootState,
): boolean => {
  return state.projectTourOntour.isFetchingTourTravels;
};

export const selectProjectTourIsCreatingTourTravel = (
  state: RootState,
): boolean => {
  return state.projectTourOntour.isCreatingTourTravel;
};

export const selectIsCreatingTourEvent = (state: RootState): boolean => {
  return state.projectTourOntour.isCreatingTourEvent;
};

export const selectProjecTourOnTourIsImportingTourEvents = (
  state: RootState,
): boolean => {
  return state.projectTourOntour.isImportingTourEvents;
};

export const selectProjecTourOnTourIsImportingTourEventsFromCsv = (
  state: RootState,
): boolean => {
  return state.projectTourOntour.isImportingTourEventsFromCsv;
};

export const selectProjectTourOnTourPositionsHistoryIncoming = (
  state: RootState,
): PositionGeocode[] => {
  let positions = state.projectTourOntour.tourTravels
    .filter((item) => item.connexionTypeWithEvent === 'incoming')
    .filter((item) => item.fromPosition !== undefined)
    .map((item) => item.fromPosition as PositionGeocode)
    .sort((a, b) => a.properties.name.localeCompare(b.properties.name));
  positions = removeDuplicatePositions(positions);
  return positions;
};

export const selectProjectTourOnTourPositionHistoryListOutcoming = (
  state: RootState,
): PositionGeocode[] => {
  let positions = state.projectTourOntour.tourTravels
    .filter((item) => item.connexionTypeWithEvent === 'outgoing')
    .filter((item) => item.toPosition !== undefined)
    .map((item) => item.toPosition as PositionGeocode)
    .sort((a, b) => a.properties.name.localeCompare(b.properties.name));
  positions = removeDuplicatePositions(positions);
  return positions;
};

function removeDuplicatePositions(positions: PositionGeocode[]) {
  const uniquePositions = Array.from(
    new Map(
      positions.map((pos) => [
        `${pos.coordinates[0]},${pos.coordinates[1]}`,
        pos,
      ]),
    ).values(),
  );
  return uniquePositions;
}
